const Box = (props) => props.children;

export default Box;